const SECONDS_IN_ONE_CREDIT = 60

export const turnBilledDurationSecondsInCredits = (billedDurationSeconds: number): number => {
	return parseFloat((billedDurationSeconds / SECONDS_IN_ONE_CREDIT).toFixed(1))
}
